import { render, staticRenderFns } from "./shipping-cost.vue?vue&type=template&id=e28a84a4&scoped=true"
import script from "./shipping-cost.vue?vue&type=script&lang=ts"
export * from "./shipping-cost.vue?vue&type=script&lang=ts"
import style0 from "./shipping-cost.vue?vue&type=style&index=0&id=e28a84a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28a84a4",
  null
  
)

export default component.exports